export const purchaseUrl = 'https://combo-completo-hipertrofia.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/aiAXgT4CxSbRwm3vmrFQnW/ChatGPT_Image_11_sept_2026,_07_49_33_p.m..png'

export const heroStats = [
  ['+200', 'entrenadores confían'],
  ['6', 'Tomos listos'],
  ['5', 'Bonos incluidos'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'JC',
    name: 'Juan C.',
    place: 'Buenos Aires · Profesor de Gimnasio',
    text: 'Programé 52 semanas en una tarde. Mis alumnos ganaron 4-6 kg de músculo en 12 semanas sin lesiones.',
  },
  {
    initials: 'MP',
    name: 'Martín P.',
    place: 'Córdoba · Entrenador de Fuerza',
    text: 'Los protocolos para lumbalgia me permitieron entrenar a alumnos que creía que no podía. Ahora es mi especialidad.',
  },
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'Mendoza · Preparadora Física',
    text: 'Finalmente tengo 20 perfiles de alumnos resueltos. No más improvisación. Cada sesión tiene un propósito.',
  },
]

export const developedTestimonials = [
  {
    initials: 'JC',
    name: 'Juan C.',
    place: 'Buenos Aires · 38 años · Profesor de Gimnasio',
    result: 'De 5 a 20 alumnos en 6 meses',
    text: 'Pasaba los fines de semana armando programas que después no funcionaban. Con los Tomos 1 a 4 diseñé una estructura clara: principiante, intermedio y avanzado. En 6 meses pasé de 5 a 20 alumnos pagando. Mis clientes VEN que PROGRESAN y eso es lo que los hace quedarse.',
  },
  {
    initials: 'MR',
    name: 'Matías R.',
    place: 'Córdoba · 45 años · Dueño de gimnasio',
    result: 'Retención del 55% al 92%',
    text: 'Mi problema eran los grupos mixtos: sedentarios y avanzados en el mismo horario. Con el Tomo 3 y el Bono 5 cada alumno tiene su versión del programa. La retención pasó de 55% a 92% y hoy mis propios alumnos recomiendan las clases sin que yo pida.',
  },
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'Mendoza · 40 años · Preparadora Física',
    result: '8 meses sin lesiones en grupo de adultos mayores',
    text: 'Le tenía miedo a entrenar adultos mayores por el riesgo. Con el Tomo 3 abrí un grupo de 50-70 años: 18 personas, 8 meses, cero lesiones. Es el grupo más estable que tengo y el que más me recomienda. La seguridad vende.',
  },
  {
    initials: 'LB',
    name: 'Lucas B.',
    place: 'Rosario · 28 años · Entrenador de Fuerza',
    result: 'Agenda llena en 3 meses',
    text: 'Salí de la carrera sabiendo teoría pero sin saber armar un ciclo real. El Tomo 1 me dio la estructura y el Bono 5 me mostró 20 casos resueltos. En tres meses llené la agenda sin gastar un peso en publicidad, solo mostrando resultados de alumnos.',
  },
  {
    initials: 'VA',
    name: 'Valeria A.',
    place: 'Mar del Plata · 32 años · Entrenadora especializada',
    result: '+4 kg de masa muscular promedio en 12 semanas',
    text: 'Entreno principalmente mujeres y siempre adaptaba a ojo. Con el Tomo 2 (especialización) y el Bono 4 (progresiones) mis alumnas ganaron 4 kg de promedio en 12 semanas. Tres de ellas ganaron visibilidad en redes y ahora me recomiendan constantemente.',
  },
  {
    initials: 'CM',
    name: 'Carlos M.',
    place: 'La Plata · 50 años · Profesor con alumnos sedentarios',
    result: 'De “no puedo” a “sí puedo”',
    text: 'Tengo alumnos que hace 10 años no se movían. Con el Bono 3 (Sedentarios y Sobrepeso) por primera vez tengo un protocolo paso a paso. Tres de ellos ya perdieron 8 kg cada uno y me dicen que es la primera vez que se sienten capaces. Eso no tiene precio.',
  },
]

export const modules = [
  {
    icon: '📋',
    name: 'Tomo 1 — Hipertrofia de Principiante a Avanzado',
    period: 'Del bodypump a la ganancia real',
    content: [
      '5 perfiles: Principiante, Intermedio I, Intermedio II, Avanzado y Élite',
      'Frecuencias: 2, 3, 4, 5 y 6 días por semana',
      'Progresión paso a paso: cómo sumar carga inteligentemente',
      'Rutinas completas: Full Body, Upper/Lower y Push/Pull/Legs',
      'Descargas obligatorias: cuándo y cómo recuperarse',
    ],
  },
  {
    icon: '💪',
    name: 'Tomo 2 — Hipertrofia según Objetivo Muscular',
    period: '¿Tu alumno quiere glúteos, brazos o espalda?',
    content: [
      'Especialización de glúteos: 4 semanas de progresión',
      'Especialización de pecho: volumen máximo',
      'Especialización de espalda: lats gigantes',
      'Especialización de brazos: bíceps y tríceps',
      'Especialización de hombros: deltoides completos',
    ],
  },
  {
    icon: '👴',
    name: 'Tomo 3 — Hipertrofia para Adultos Mayores',
    period: 'Entrenar a mayores de 50 sin miedo a lesiones',
    content: [
      'Adaptaciones por edad: 50-60, 60-70 y 70+',
      'Movilidad y seguridad: prevención de caídas',
      'Progresión conservadora pero real',
      'Recuperación optimizada',
    ],
  },
  {
    icon: '🧒',
    name: 'Tomo 4 — Hipertrofia para Adolescentes',
    period: 'De los 14 a los 20 años: desarrollo óptimo',
    content: [
      'Adaptaciones por etapa del desarrollo',
      'Técnica primero, carga después',
      'Potencia y ganancia simultánea',
      'Prevención de lesiones de crecimiento',
    ],
  },
  {
    icon: '🏥',
    name: 'Tomo 5 — Entrenamiento Adaptado: Lumbalgia y Hernia Discal',
    period: 'Tu alumno tiene dolor de espalda. ¿Qué hacés?',
    content: [
      '3 niveles: inicial, intermedio y avanzado',
      'Máquinas vs barras: cuándo usar cada una',
      'Core reforzado: 10 minutos EXTRA de estabilidad',
      'Progresión segura: de máquinas a barras ligeras',
      'Casos resueltos: del reposo a la sentadilla pesada',
    ],
  },
  {
    icon: '🦵',
    name: 'Tomo 6 — Adaptación para Salud Articular: Cervicalgia y Rodilla',
    period: '¿Cervical dolorida? ¿Rodilla molesta? Solución.',
    content: [
      'Adaptaciones para cervicalgia: agarre cerrado y cuello neutro',
      'Adaptaciones para rodilla: rango controlado y máquinas',
      'Combinado (ambas limitaciones): 4 días específicos',
      'Regreso progresivo: cuándo volver a lo “normal”',
    ],
  },
]

export const bonuses = [
  {
    number: '01',
    icon: '🎁',
    name: 'Biblioteca completa de sustituciones',
    value: '$11.990',
    description: '500+ variantes de ejercicios organizadas y listas para usar.',
    items: [
      'Sentadilla: 30+ variantes por limitación',
      'Remo: 20+ variantes',
      'Press: 25+ variantes',
      'Jalón: 15+ variantes',
      'Cada una con series, reps, RIR y descanso',
      'Organizadas por equipamiento, limitación articular y nivel',
    ],
  },
  {
    number: '02',
    icon: '⏱️',
    name: 'Rutinas express',
    value: '$9.990',
    description: '30, 45 y 60 minutos para el alumno ocupado.',
    items: [
      '9 rutinas completas (Full Body y split)',
      'Para cuando tu alumno dice: “solo tengo 30 minutos”',
      'Supersets y trisets: máximo volumen, mínimo tiempo',
      'Progresión modificada: cómo avanzar en tiempo reducido',
    ],
  },
  {
    number: '03',
    icon: '🔥',
    name: 'Sedentarios, sobrepeso y baja condición física',
    value: '$12.990',
    description: 'De la silla al gimnasio sin lesionarse.',
    items: [
      '3 fases de 4 semanas cada una (12 semanas totales)',
      'Adaptación → Desarrollo → Consolidación',
      'Caso típico: señora de 50 años con 30 kg de sobrepeso',
      'Resultados reales: -5 a -8 kg en 12 semanas',
    ],
  },
  {
    number: '04',
    icon: '⚙️',
    name: 'Progresiones, estancamientos y descargas',
    value: '$10.990',
    description: 'Cómo lograr que tu alumno progrese SIEMPRE.',
    items: [
      '4 variables de progresión: reps, carga, series y densidad',
      'Árbol de decisión: ¿qué variable progresar hoy?',
      'Detección de estancamientos: 5 preguntas diagnósticas',
      'Descargas estratégicas: cuándo y cómo',
      'Protocolos paso a paso',
    ],
  },
  {
    number: '05',
    icon: '🧩',
    name: 'Perfiles de alumnos resueltos',
    value: '$12.990',
    description: '20 casos prácticos completamente resueltos.',
    items: [
      'El ejecutivo sedentario',
      'La chica fitness principiante',
      'El futbolista que se lesiona',
      'La mamá de 42 años',
      'El joven deportista y la abuela de 68 años',
      'Y 14 casos más reales, con evaluación, programa y resultados proyectados',
    ],
  },
] as const

export const pains = [
  'Programas que “más o menos funcionan” porque les falta estructura.',
  'Siempre los mismos ejercicios: no tenés un sistema de progresión claro.',
  'Alumnos de distintos niveles sin planes diferenciados.',
  'Sedentarios que no saben por dónde empezar.',
  'Alumnos con lumbalgia que no podés entrenar.',
  'Adultos mayores que parecen “riesgo”.',
  'Adolescentes que quieren ponerse grandes.',
  'Horas perdidas buscando “cómo adaptar” cuando necesitás la respuesta YA.',
  'La frustración de un alumno que no progresa pese a entrenar durísimo.',
]

export const included = [
  '6 Tomos completos: hipertrofia general, especialización muscular, adultos mayores, adolescentes, lumbalgia y articulaciones',
  'BONO 1 — Biblioteca de 500+ Sustituciones (gratis)',
  'BONO 2 — Rutinas Express 30/45/60 min (gratis)',
  'BONO 3 — Sedentarios y Sobrepeso (gratis)',
  'BONO 4 — Progresiones y Descargas (gratis)',
  'BONO 5 — 20 Perfiles de Alumnos Resueltos (gratis)',
  'Garantía de 7 días sin preguntas',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Son 6 tomos progresivos: desde Hipertrofia General (todos los niveles) hasta Especialización Muscular y Adaptaciones Especiales. Elegís dónde empezar según tu alumno: desde principiante absoluto hasta avanzado buscando especialización.',
  ],
  [
    '¿Cómo recibo el material?',
    'Acceso instantáneo. Después de confirmar tu pago (2-5 minutos en Mercado Pago) recibís un email con tu usuario y contraseña. Descargás todos los PDF y los usás offline si querés.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, 7 días de garantía sin preguntas. Si en esos 7 días probás el material y no es para vos, escribís a compradigitalyaa@gmail.com y te devolvemos el 100% del dinero. Sin reclamos, sin drama. Nuestra tasa de devoluciones es menor al 0,5% porque el material funciona.',
  ],
  [
    '¿Necesito certificación previa para usar esto?',
    'No es obligatorio, pero sí recomendable tener experiencia básica en gimnasio. El material está hecho para profesores que entrenan y quieren SISTEMA. Si sos completamente principiante como entrenador, te recomendamos primero hacer un curso básico de técnica.',
  ],
  [
    '¿Sirve para alumnos con limitaciones (lumbalgia, cervicalgia, rodilla)?',
    'Sí. Los Tomos 5 y 6 están 100% dedicados a esto. Además, el Bono 5 (Perfiles Resueltos) incluye 8 casos de alumnos con limitaciones específicas, resueltos completamente.',
  ],
  [
    '¿Cómo puedo pagar?',
    'Mercado Pago (tarjeta de débito o crédito), transferencia bancaria y efectivo en algunos casos. El pago es 100% seguro y encriptado.',
  ],
  [
    '¿Tendré acceso a actualizaciones futuras?',
    'Sí. Cualquier update o mejora de contenido lo recibís en tu cuenta sin costo extra. Es acceso de por vida.',
  ],
  [
    '¿Me sirve si entreno online y no tengo gimnasio propio?',
    'Sí. El 80% del material es adaptable online. El Bono 2 (Rutinas Express) está específicamente pensado para entrenamientos en casa, y las adaptaciones con mancuernas o bandas son ideales para entrenamiento online.',
  ],
  [
    '¿Incluye la programación semana a semana (lunes, martes, miércoles…)?',
    'Sí. El Tomo 1 incluye distribuciones semanales completas para 2, 3, 4, 5 y 6 días. El Tomo 2 también tiene bloques semanales según especialización.',
  ],
  [
    '¿Puedo usarlo para capacitar a mi equipo de entrenadores?',
    'No. Es de uso personal para el entrenador que compra. Si querés licencia de equipo (múltiples usuarios), escribí a compradigitalyaa@gmail.com para opciones B2B.',
  ],
] as const

export const recentPurchases = [
  ['Nicolás Ferreyra', 'Rosario, Santa Fe'],
  ['Julián Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Agustín Rojas', 'Godoy Cruz, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Damián Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén Capital, Neuquén'],
  ['Nahuel Ojeda', 'Salta Capital, Salta'],
  ['Florencia Alsina', 'Bahía Blanca, Buenos Aires'],
  ['Emiliano Duarte', 'Posadas, Misiones'],
] as const
